import React from "react";
import PropTypes from "prop-types";
import genTextClassPop from "../utils/genTextClassPop";

const Heading = ({ countyClass }) => {
  const popText = genTextClassPop(countyClass);
  return (
    <div className="heading__container">
      Counties with populations&nbsp;{popText}:
    </div>
  );
};

Heading.propTypes = {
  countyClass: PropTypes.string.isRequired,
};

export default Heading;
